// @ts-strict-ignore
import { ReservableExtraListQueryVariables } from '~/generated/graphql'

import { AllQueryVariables } from '../../ListingPageContent/ListingPageContentTypes'

import { ChefsMenuFilterSettings } from './ChefsMenuListingPageTypes'

export const PAGE_SIZE = 9

export const chefsMenuDefaultFilterSettings: ChefsMenuFilterSettings = {
  region: undefined,
  tags: [],
}

export const getReservableExtraListQueryVariables = ({
  selectedRegion,
  filters,
  endCursor,
  first,
}: AllQueryVariables): ReservableExtraListQueryVariables => {
  if (filters?.tags?.length > 0) {
    return {
      regionIds: [selectedRegion.id],
      restaurantTags: filters.tags,
      first: first,
      after: endCursor,
    }
  }
  return {
    regionIds: [selectedRegion.id],
    first: first,
    after: endCursor,
  }
}
